<script>
    import gsap from 'gsap';
    import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
    import {onMount, onDestroy} from "svelte";

    gsap.registerPlugin(DrawSVGPlugin);

    let drawLine;
    let tl = gsap.timeline();
    let svgElement;

    onMount(() => {
        const paths = [...Array.from(svgElement.getElementsByTagName('path')), ...Array.from(svgElement.getElementsByTagName('line')), ...Array.from(svgElement.getElementsByTagName('circle'))];

        tl.fromTo(paths, {
            drawSVG: "100% 100%",
            transformOrigin: 'center center',
        }, {
            drawSVG: "100% 0%",
            stagger: 0.01,
            duration: 0.5,
        }, 0);

        tl.play();
    });

    onDestroy(() => {
        tl.clear();
        tl = null;
    })
</script>

<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 380 678" bind:this={svgElement}>
    <defs>
        <clipPath id="clip-path">
            <rect id="Rectangle_570" data-name="Rectangle 570" width="263.135" height="194.982" fill="none"/>
        </clipPath>
    </defs>
    <rect id="Rectangle_865" data-name="Rectangle 865" width="380" height="678"/>
    <text id="Will_your_ideas_get_noticed_by_the_C-suite_" data-name="Will your ideas get noticed by
the C-suite?" transform="translate(39 51.446)" fill="#fcd0b1" font-size="24" font-family="Metric">
        <tspan x="0" y="0">Will your ideas get noticed by</tspan>
        <tspan x="0" y="28">the C-suite?</tspan>
    </text>
    <text id="Business_leaders_are_spending_more_time_than_ever_consuming_business_content"
          data-name="Business leaders are spending more time than ever consuming business content"
          transform="translate(39 121)" fill="#fff" font-size="24" font-family="Metric">
        <tspan x="0" y="18">Business leaders are</tspan>
        <tspan x="0" y="46">spending more time than</tspan>
        <tspan x="0" y="74">ever consuming business</tspan>
        <tspan x="0" y="102">content</tspan>
    </text>
    <text id="_5_" data-name="5 " transform="translate(39 400)" fill="#fff" font-size="86"
          font-family="Metric-Bold, Metric" font-weight="700">
        <tspan x="0" y="66">5</tspan>
        <tspan y="66" font-size="24" font-family="Metric" font-weight="400"></tspan>
    </text>
    <text id="hours_a_week" data-name="hours a week" transform="translate(39 475)" fill="#fff" font-size="24"
          font-family="Metric">
        <tspan x="0" y="18">hours a week</tspan>
    </text>
    <g id="Group_1154" data-name="Group 1154" transform="translate(58 260)">
        <g id="Group_1151" data-name="Group 1151">
            <g id="Group_1150" data-name="Group 1150" clip-path="url(#clip-path)">
                <path id="Path_14528" data-name="Path 14528" d="M231.853,95.366v98.616H63.072v-68.02" fill="none"
                      stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </g>
        </g>
        <path id="Path_14529" data-name="Path 14529" d="M127.193,63.854H231.852v33.67" fill="none" stroke="#008ed2"
              stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        <rect id="Rectangle_571" data-name="Rectangle 571" width="20.231" height="40.96"
              transform="translate(76.401 137.868)" fill="none" stroke="#008ed2" stroke-linecap="round"
              stroke-linejoin="round" stroke-width="2"/>
        <rect id="Rectangle_572" data-name="Rectangle 572" width="20.231" height="40.96"
              transform="translate(96.632 137.868)" fill="none" stroke="#008ed2" stroke-linecap="round"
              stroke-linejoin="round" stroke-width="2"/>
        <rect id="Rectangle_573" data-name="Rectangle 573" width="20.231" height="40.96"
              transform="translate(116.864 137.868)" fill="none" stroke="#008ed2" stroke-linecap="round"
              stroke-linejoin="round" stroke-width="2"/>
        <rect id="Rectangle_574" data-name="Rectangle 574" width="20.231" height="40.96"
              transform="translate(137.095 137.868)" fill="none" stroke="#008ed2" stroke-linecap="round"
              stroke-linejoin="round" stroke-width="2"/>
        <rect id="Rectangle_575" data-name="Rectangle 575" width="20.231" height="40.96"
              transform="translate(157.327 137.868)" fill="none" stroke="#008ed2" stroke-linecap="round"
              stroke-linejoin="round" stroke-width="2"/>
        <rect id="Rectangle_576" data-name="Rectangle 576" width="20.231" height="40.96"
              transform="translate(177.558 137.868)" fill="none" stroke="#008ed2" stroke-linecap="round"
              stroke-linejoin="round" stroke-width="2"/>
        <rect id="Rectangle_577" data-name="Rectangle 577" width="20.736" height="40.96"
              transform="translate(197.789 137.868)" fill="none" stroke="#008ed2" stroke-linecap="round"
              stroke-linejoin="round" stroke-width="2"/>
        <path id="Path_14530" data-name="Path 14530"
              d="M86.676,161.888l-4.8-7.786v10.705H80.837V152.094h.932l4.949,8.075,4.969-8.075h.87v12.713H91.522V154.1l-4.784,7.786Z"
              fill="#008ed2"/>
        <path id="Path_14531" data-name="Path 14531" d="M101.834,152.094h10.354v.973h-4.66v11.74h-1.055v-11.74h-4.639Z"
              fill="#008ed2"/>
        <path id="Path_14532" data-name="Path 14532"
              d="M127.485,152.094l2.982,10.933,2.941-10.933h1.035l-3.458,12.713h-.953l-3-10.829-2.982,10.829h-.931l-3.48-12.713h1.057l2.94,10.933,2.982-10.933Z"
              fill="#008ed2"/>
        <path id="Path_14533" data-name="Path 14533" d="M141.317,152.094h10.354v.973h-4.66v11.74h-1.055v-11.74h-4.639Z"
              fill="#008ed2"/>
        <path id="Path_14534" data-name="Path 14534"
              d="M163.428,164.807V152.094H170.8v.973h-6.315v4.845h5.984v.952h-5.984v5.943Z" fill="#008ed2"/>
        <g id="Group_1153" data-name="Group 1153">
            <g id="Group_1152" data-name="Group 1152" clip-path="url(#clip-path)">
                <path id="Path_14535" data-name="Path 14535"
                      d="M182.591,162.509a5.525,5.525,0,0,0,3.935,1.512c1.821,0,2.981-.911,2.981-2.382,0-1.283-.725-1.8-2.278-2.463l-1.864-.788c-1.325-.559-2.753-1.325-2.753-3.251,0-2.153,1.8-3.23,3.851-3.23a6.151,6.151,0,0,1,3.562,1.077v1.18a5.277,5.277,0,0,0-3.541-1.283c-1.574,0-2.837.745-2.837,2.236,0,1.242.87,1.781,2.215,2.319l1.967.828c1.865.807,2.713,1.719,2.713,3.354,0,2.03-1.7,3.376-4.016,3.376a6.069,6.069,0,0,1-3.935-1.263Z"
                      fill="#008ed2"/>
                <path id="Path_14536" data-name="Path 14536"
                      d="M204.083,162.509a5.525,5.525,0,0,0,3.935,1.512c1.821,0,2.981-.911,2.981-2.382,0-1.283-.725-1.8-2.278-2.463l-1.864-.788c-1.325-.559-2.753-1.325-2.753-3.251,0-2.153,1.8-3.23,3.851-3.23a6.151,6.151,0,0,1,3.562,1.077v1.18a5.277,5.277,0,0,0-3.541-1.283c-1.574,0-2.837.745-2.837,2.236,0,1.242.87,1.781,2.215,2.319l1.967.828c1.865.807,2.713,1.719,2.713,3.354,0,2.03-1.7,3.376-4.016,3.376a6.069,6.069,0,0,1-3.935-1.263Z"
                      fill="#008ed2"/>
                <path id="Path_14537" data-name="Path 14537" d="M63.944,17.322V63.468l23.71,40.557" fill="none"
                      stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                <line id="Line_7797" data-name="Line 7797" transform="translate(92.576 99.25)" fill="none" stroke="#fff"
                      stroke-linecap="round" stroke-linejoin="round" stroke-width="2.813"/>
                <path id="Path_14538" data-name="Path 14538" d="M92.576,99.25q1.763-1.3,3.388-2.76" fill="none"
                      stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.813"
                      stroke-dasharray="0 10.741"/>
                <path id="Path_14539" data-name="Path 14539"
                      d="M100.389,91.919a44.514,44.514,0,0,0,10.476-28.734A44.991,44.991,0,0,0,76.222,19.523"
                      fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.813"
                      stroke-dasharray="0 10.741"/>
                <line id="Line_7798" data-name="Line 7798" transform="translate(70.934 18.59)" fill="none" stroke="#fff"
                      stroke-linecap="round" stroke-linejoin="round" stroke-width="2.813"/>
                <path id="Path_14540" data-name="Path 14540"
                      d="M1,63.468C1,28.968,29.181,1,63.944,1s62.943,27.968,62.943,62.468-28.181,62.468-62.943,62.468S1,97.968,1,63.468Z"
                      fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                <path id="Path_14541" data-name="Path 14541"
                      d="M38.271,25.037a1.461,1.461,0,1,1,2,.535,1.461,1.461,0,0,1-2-.535" fill="#008ed2"/>
                <path id="Path_14542" data-name="Path 14542"
                      d="M22.592,43.078a1.461,1.461,0,1,1,2-.535,1.462,1.462,0,0,1-2,.535" fill="#008ed2"/>
                <path id="Path_14543" data-name="Path 14543"
                      d="M18.034,66.541A1.462,1.462,0,1,1,19.5,65.08a1.461,1.461,0,0,1-1.461,1.461" fill="#008ed2"/>
                <path id="Path_14544" data-name="Path 14544"
                      d="M25.818,89.14a1.461,1.461,0,1,1,.535-2,1.461,1.461,0,0,1-.535,2" fill="#008ed2"/>
                <path id="Path_14545" data-name="Path 14545"
                      d="M43.859,104.819a1.461,1.461,0,1,1-.535-2,1.462,1.462,0,0,1,.535,2" fill="#008ed2"/>
                <path id="Path_14546" data-name="Path 14546"
                      d="M67.322,109.377a1.461,1.461,0,1,1-1.461-1.461,1.461,1.461,0,0,1,1.461,1.461" fill="#008ed2"/>
                <path id="Path_14547" data-name="Path 14547"
                      d="M166.123,104.422A15.627,15.627,0,1,1,150.5,88.795,15.627,15.627,0,0,1,166.123,104.422Z"
                      fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                <path id="Path_14548" data-name="Path 14548"
                      d="M218.493,104.422a15.626,15.626,0,1,1-15.627-15.627A15.627,15.627,0,0,1,218.493,104.422Z"
                      fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                <path id="Path_14549" data-name="Path 14549"
                      d="M166.123,104.422s5.35-3.8,10.7-3.8,10.418,3.8,10.418,3.8" fill="none" stroke="#fff"
                      stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                <path id="Path_14550" data-name="Path 14550"
                      d="M157.055,89.419l15.208-10.285a4.186,4.186,0,0,1,6.531,3.467" fill="none" stroke="#fff"
                      stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                <path id="Path_14551" data-name="Path 14551"
                      d="M218.587,104.188,255.6,79.135a4.186,4.186,0,0,1,6.531,3.467" fill="none" stroke="#fff"
                      stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </g>
        </g>
    </g>
</svg>
